import React, { useEffect, useState, useContext, useRef } from 'react';
import { Modal, Carousel, Form, Spinner } from 'react-bootstrap';
import VisaIcon from '../assets/images/icons/Visa.svg';
import MastercardIcon from '../assets/images/icons/mastercard.svg';
import Walletcard from '../assets/images/icons/Wallet-card-BCBSAZ.svg';
import BankIcon from '../assets/images/Overview/Bank-Autopay.svg';
import EncryptIcon from '../assets/images/icons/Encrypt.svg';
import SuccessImage from '../assets/images/Illustrations/Autopay-Confirmation.svg';
import SuccessImageQ5 from '../assets/images/Illustrations/Autopay-Confirmation-Q5.svg';
import Forms from "../components/forms.jsx";
import "../styles/AutoPay.css";
import { useNavigate } from 'react-router-dom';
import { GetPayLoad } from '../services/PayLoadStorage.jsx';
import { getApiService, postApiService } from '../services/ApiService.jsx';
import { toast } from 'react-toastify';
import moment from "moment";
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';
import Cookies from 'js-cookie';
import nextarrow from "../assets/images/icons/Next-arrow.svg";
import previousarrow from "../assets/images/icons/Previous-Arrow.svg";

const AutoPayModal = ({ setModalText, sendDataToCard, billingContent, genericContent }) => {

    const ref = useRef(null);
    const step1Ref = useRef(null);
    const step2Ref = useRef(null);
    const [apiCallCompleted, setApiCallCompleted] = useState(false);
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const Payload = GetPayLoad('PayLoad');
    const targetGetActiveAccountsUrl = process.env.REACT_APP_API_GET_ACTIVE_ACCOUNTS_ENDPOINT;
    const headers = {
        "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
        "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
        "X-Hps-Region": Payload?.region,
        "X-Hps-Carrier": Payload?.owning_carrier
    };
    let currentDate = moment(). format('MM/DD/YYYY');

    const [activeStep, setActiveStep] = useState(1);
    const [isLoading, setLoading] = useState(true);
    const [selectedCard, setSelectedCard] = useState(null);
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [autopayEnabled, setAutopayEnabled] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [activeAccounts, setActiveAccounts] = useState([]);
    const navigate = useNavigate();
    const [primaryAccount, setPrimaryAccount] = useState([]);
    const [errorFlag, setErrorFlag] = useState(false);
    const [cardId, setCardToken] = useState(null);
    const [billingInfo, setBillingInfo] = useState([]);
    const [isBillingInfoLoading, setBillingInfoLoading] = useState(true);
    const [billingInfoErrorFlag, setBillingInfoErrorFlag] = useState(false);
    const [autopayAccount, setAutopayAccount] = useState([]);
    const [autopayStatus, setAutopayStatus] = useState(['Enabled']);
    const [isAutopayLoading, setAutopayLoading] = useState(false);
    const [addNew, setAddNew] = useState(false);
    const [caseInfo, setCaseInfo] = useState([]);
    const [caseInfoErrorFlag, setCaseInfoErrorFlag] = useState(false);
    const [PlusIcon, setPlusIcon] = useState(null);
    const [totalPremium, setTotalPremium] = useState(0);
    
    const owningCarrier = Cookies.get('owningCarrier') || '';
    
    const slideRefs = useRef([]);
    const [active, setActive] = useState(0);
    const [action, setAction] = useState(null);

    const handleAddNew = (e) => {
        e.preventDefault();
        setAddNew(true);
    }
    const handleCloseModal = () => {
        setShowModal(false);
    };

    function handleAddNewDataForm(message,response) {
        if (message !== '') {
            if (response === 'success') {
                toast.success(message);
            } else {
                toast.error(message);
            }
        }
        fetchAPI();
    }
    
    useEffect(() => {
        const el = slideRefs.current[active];
        el?.focus();
    }, [active]);

    useEffect(() => {   
        const targetBillingDetailsUrl = process.env.REACT_APP_API_CASE_BILL_DETAILS_ENDPOINT;
        getApiService(baseUrl, targetBillingDetailsUrl, { cim: Payload?.cim, apiSource: 'recentBilling' }, headers)
            .then((response) => {
                setBillingInfoLoading(false);
                if (response?.data?.statusCode !== 200) {
                    setBillingInfoErrorFlag(true);
                }else{
                    const result = response.data.data;
                    setBillingInfo(result);
                }
            })
            .catch(error => {
                setBillingInfoLoading(false);
                setBillingInfoErrorFlag(true);
            });
        
        // Fetching coverage data to check to calculate the total premium only not termed cases - st48236
		const targetCoverageUrl = process.env.REACT_APP_API_COVERAGE_INFO_ENDPOINT;
		getApiService(baseUrl, targetCoverageUrl, { cim: Payload?.cim }, headers)
			.then((response) => {
				if (response?.data?.statusCode !== 200) {
					setErrorFlag(true);
				} else {
					const arrCoveragesPrd = response.data.data.coverages;
					// Calculate total premium for non-termed cases
					let calculatedPremium = 0;
					arrCoveragesPrd.forEach((coverage) => {
						if (coverage?.dtlCaseStatus?.toLowerCase() !== 'termed') {
							// Parse premium amount, removing currency symbols and commas
							const premiumValue = parseFloat(coverage?.premiumAmt?.replace(/[^0-9.-]+/g, '') || 0);
							calculatedPremium += premiumValue;
						}
					});
					setTotalPremium(calculatedPremium);
				}
			})
			.catch(error => {
				console.error('Error fetching coverage data:', error);
			});

        fetchAPI();
    }, []);

    const gotoPrev = () => {
        setActive(i => (i - 1 + activeAccounts.length) % activeAccounts.length);
        setAction('prev');
    };
    const gotoNext = () => {
        setActive(i => (i + 1) % activeAccounts.length);
        setAction('next');
    };

    const onKeyDown = (e) => {
        if (e.key === "ArrowRight") { e.preventDefault(); gotoNext(); }
        if (e.key === "ArrowLeft")  { e.preventDefault(); gotoPrev(); }
    };

    function fetchAPI() {

        const targetGetAutopayStatusUrl = process.env.REACT_APP_API_GET_AUTOPAY_STATUS_ENDPOINT;
        getApiService(baseUrl, targetGetAutopayStatusUrl, { cim: Payload?.cim }, headers)
            .then((response) => {
                if (response?.data?.statusCode !== 200) {
                    setErrorFlag(true);
                }else{
                    setErrorFlag(false);
                    const result = response.data.data;
                    setAutopayAccount(result);
                    setCardToken(result?.tokenId.trim());
                    setSelectedCard(result?.lastFour);
                    setAutopayEnabled(result?.count > 0 ? false: true);
                    setTermsAccepted(result?.count > 0 ? true: false);
                    setActiveStep(result?.count > 0 ? 2 : 1);
                }
            })
            .catch(error => {
                setErrorFlag(true);
            });

        const targetGetPrimaryAccountUrl = process.env.REACT_APP_API_GET_PRIMARY_ACCOUNT_ENDPOINT;
        getApiService(baseUrl, targetGetPrimaryAccountUrl, { cim: Payload?.cim }, headers)
            .then((response) => {
                setLoading(false);
                if (response?.data?.statusCode !== 200) {
                    setErrorFlag(true);
                }else{
                    setErrorFlag(false);
                    const result = response.data.data;
                    setPrimaryAccount(result);
                }
            })
            .catch(error => {
                setLoading(false);
                setErrorFlag(true);
            });

        getApiService(baseUrl, targetGetActiveAccountsUrl, { cim: Payload?.cim }, headers)
            .then((response) => {
                setLoading(false);
                if (response?.data?.statusCode !== 200) {
                    setErrorFlag(true);
                }else{
                    setErrorFlag(false);
                    const result = response.data.data;
                    const alteredData = result.map((obj) => {
                        return {
                            ...obj,
                            icon: obj.detailedAccountType === "MC" ? MastercardIcon : (obj.detailedAccountType === "VISA" ? VisaIcon : BankIcon),
                        }
                    })
                    setActiveAccounts(alteredData);
                }
            })
            .catch(error => {
                setLoading(false);
                setErrorFlag(true);
            });

        const targetCaseUrl = process.env.REACT_APP_API_CASE_INFO_ENDPOINT;
        getApiService(baseUrl, targetCaseUrl, { cim: Payload?.cim }, headers)
            .then((response) => {
                if (response?.data?.statusCode !== 200) {
                    setCaseInfoErrorFlag(true);
                } else {
                    const result = response.data.data;
                    setCaseInfoErrorFlag(false);
                    setCaseInfo(result);
                    setApiCallCompleted(true);
                }
            })
            .catch(error => {
                setCaseInfoErrorFlag(true);
            });
    }

    
    const chunk = (arr, size) =>
        arr.reduce((acc, _, i) => (i % size ? acc : [...acc, arr.slice(i, i + size)]), []);

    // Keep only Debit cards
    const debitAccounts = activeAccounts.filter(
        (acc) => (acc.cardType !== 'CCD')
    );

    let groupedAccounts = [];
    if(Cookies.get("owningCarrier") === "Q5" && Cookies.get("binder_payment_flag") === "false"){
        groupedAccounts = chunk(debitAccounts, 2);
    }else{
        groupedAccounts = chunk(activeAccounts, 2);
    }
    
    
    // const groupedAccounts = [
    //     {
    //         type: 'cc',
    //         cards: activeAccounts.filter((acc) => acc.mainAccountType === 'CCD'),
    //     },
    //     {
    //         type: 'eft',
    //         cards: activeAccounts.filter((acc) => acc.mainAccountType === 'EFT'),
    //     },
    // ];

    const handleCardSelect = (token, lastFour) => {
        setSelectedCard(lastFour);
        setCardToken(token);
    };

    const handleNext = () => {
        if (activeStep === 1 && !selectedCard) {
            return;
        }
        setActiveStep(activeStep + 1);
    };

    const handleBack = () => {
        setActiveStep(activeStep - 1);
    };

    const handleAutopay = (accType, vaultId) => {
        setAutopayLoading(true);

        const targetSaveAutopayUrl = process.env.REACT_APP_API_SAVE_AUTOPAY_ENDPOINT;
        const payload = new FormData();
        payload.append("cim", Payload?.cim);
        payload.append("account_type", accType);
        payload.append("vault_id", vaultId);
        payload.append("autopayEnabled", autopayEnabled);
        postApiService(baseUrl, targetSaveAutopayUrl, payload, headers)
            .then((response) => {
                setAutopayLoading(false);
                if (response?.data?.statusCode !== 200) {
                    toast.error(genericContent?.service_post_error);
                }else{
                    setAutopayStatus(autopayEnabled ? billingContent?.billing_autopay_enabled_text : billingContent?.billing_autopay_disabled_text);
                    setActiveStep(3);
                    const autopay_status = autopayEnabled ? 'Disable' : 'Enable';
                    sendDataToCard(autopay_status);
                }
            })
            .catch(error => {
                setAutopayLoading(false);
                toast.error(genericContent?.service_post_error);
            });
    };

    const getSelectedCardDetails = () => {
        if (!selectedCard) return null;

        let foundCard = null;
        groupedAccounts.forEach(method => {
            activeAccounts.forEach(card => {
                if (card.tokenId.trim() === cardId) {
                    foundCard = card;
                }
            });
        });

        return foundCard;
    };

    const handlePrimaryAccount = (account_type, vaultId) => {
        setLoading(true);

        const targetPrimaryAccountUrl = process.env.REACT_APP_API_SAVE_PRIMARY_ACCOUNT_ENDPOINT;
        const payload = new FormData();
        payload.append("cim", Payload?.cim);
        payload.append("accountType", account_type);
        payload.append("vaultId", vaultId);
        postApiService(baseUrl, targetPrimaryAccountUrl, payload, headers)
            .then((response) => {
                setLoading(false);
                if (response?.data?.statusCode !== 200) {
                    toast.error(genericContent?.service_post_error);
                }else{
                    toast.success(billingContent?.billing_autopay_primary_account_success_msg);
                    fetchAPI();
                }
            })
            .catch(error => {
                setLoading(false);
                toast.error(genericContent?.service_post_error);
            });
    }
    //sakthi - to calculate the total premium - for activate account
	const currentDue = parseFloat(billingInfo?.CurrentDueAmount?.replace('$', '')) || 0;
	const lastPayment = parseFloat(billingInfo?.LastPaymentRecvd?.replace('$', '')) || 0;
	const totalDueAmount = "$"+(isNaN((totalPremium!==0?totalPremium:(currentDue + lastPayment).toFixed(2))) ? 0 : (totalPremium!==0?totalPremium:(currentDue + lastPayment).toFixed(2)));
    const nachaAuthContent = DOMPurify.sanitize(getSelectedCardDetails()?.mainAccountType === 'EFT' ? billingContent?.billing_autopay_eft_recurring_nacha_content :billingContent?.billing_autopay_cc_recurring_nacha_content);
    let modifiedNachaAuthContent = nachaAuthContent;
    modifiedNachaAuthContent = nachaAuthContent ? modifiedNachaAuthContent.replace(/{{currentDate}}/g, currentDate) : '';
    modifiedNachaAuthContent = nachaAuthContent ? modifiedNachaAuthContent.replace(/{{CurrentDueAmount}}/g, totalDueAmount) : ''; //sakthi - to calculate the total premium - for activate account
    modifiedNachaAuthContent = nachaAuthContent ? modifiedNachaAuthContent.replace(/{{accountNumber}}/g, selectedCard) : '';

    const nachaNoticeCancelContent = DOMPurify.sanitize(billingContent?.billing_autopay_cc_recurring_nacha_content_notice_change_cancel);
    const nachaContentHolderContent = DOMPurify.sanitize(getSelectedCardDetails()?.mainAccountType === 'EFT' ? billingContent?.billing_autopay_eft_recurring_nacha_content_holder_agreement : billingContent?.billing_autopay_cc_recurring_nacha_content_holder_agreement);
    const enableContent = DOMPurify.sanitize(billingContent?.billing_autopay_enable_section);
    let modifiedEnableContent = enableContent;
    modifiedEnableContent = modifiedEnableContent ? modifiedEnableContent.replace(/{{status}}/g, autopayStatus) : '';
    let autopaySuccessContent = autopayEnabled ? billingContent?.billing_autopay_enable_section_desc : billingContent?.billing_autopay_disable_section_desc;
    const autopaySuccessDesc = DOMPurify.sanitize(autopaySuccessContent);

    // Focus management - immediate on render completion and step changes
    useEffect(() => {
        if (apiCallCompleted) {
            // Focus appropriate step region for automatic screen reader announcement
            const focusTarget = activeStep === 1 ? step1Ref.current : activeStep === 2 ? step2Ref.current : ref.current;
            if (focusTarget) {
                requestAnimationFrame(() => {
                    focusTarget.focus({ preventScroll: true });
                });
            }
        }
    }, [apiCallCompleted, activeStep]);

    // Dynamic import for plus icon based on carrier
    useEffect(() => {
        import("../assets/images/icons/plus-"+owningCarrier+".svg")
            .then((image) => {
                setPlusIcon(image.default);
            }).catch(() => {
                // Load default image if carrier-specific image doesn't exist
                import("../assets/images/icons/plus-circle.svg").then((image) => {
                    setPlusIcon(image.default);
                });
            });
    }, [owningCarrier]);

    return (
        <Modal.Body className="p-4 autopaymodal">
            <button type="button" className="btn-close float-end autopay-close-button" aria-label="Close" onClick={() => setModalText()}/>
            {activeStep === 3 ? (
                <div className="row py-3 form-business" role="region" aria-label="Autopay Confirmation" ref={ref} tabIndex="-1" style={{ outline: 'none' }}>
                    <div id="successMessage">
                        <div className="position-relative success-content text-center" tabIndex={0}>
                            <img src={Payload?.owning_carrier === 'Q5' ? SuccessImageQ5 : SuccessImage} className="mb-2" alt="success-message" />
                            <div className="autopay-confirmation mt-2">
                                {parse(modifiedEnableContent)}
                                {parse(autopaySuccessDesc)}
                            </div>
                            <div className="col-12">
                                {/* Responsive button order for Q5 carrier */}
                                {Payload?.owning_carrier === 'Q5' ? (
                                    <>
                                        {/* Mobile/Tablet: Go to Dashboard top, Close bottom */}
                                        <div className="q5-switch-mobile-btns d-block d-lg-none">
                                            <button
                                                className="btn btn-secondary btn-lg mt-4 col-5 dashboard-button"
                                                onClick={() => { navigate('/overview') }}
                                            >
                                                {billingContent?.billing_autopay_goto_dashboard_text}
                                            </button>
                                            
                                            <button
                                                className="me-3 btn btn-outline-secondary btn-lg mt-4 col-5 close-button"
                                                onClick={() => setModalText()}
                                            >
                                                {billingContent?.billing_autopay_close_btn_text}
                                            </button>
                                        </div>
                                        {/* Large screens: Close first, Go to Dashboard second - centered */}
                                        <div className="q5-switch-desktop-btns d-none d-lg-flex justify-content-center">
                                            <button
                                                className="me-3 btn btn-outline-secondary btn-lg mt-4 col-5 close-button"
                                                onClick={() => setModalText()}
                                            >
                                                {billingContent?.billing_autopay_close_btn_text}
                                            </button>
                                            <button
                                                className="btn btn-secondary btn-lg mt-4 col-5 dashboard-button"
                                                onClick={() => { navigate('/overview') }}
                                            >
                                                {billingContent?.billing_autopay_goto_dashboard_text}
                                            </button>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <button
                                            className="me-3 btn btn-outline-secondary btn-lg mt-4 col-5 close-button"
                                            onClick={() => setModalText()}
                                        >
                                            {billingContent?.billing_autopay_close_btn_text}
                                        </button>
                                        <button
                                            className="btn btn-secondary btn-lg mt-4 col-5 dashboard-button"
                                            onClick={() => { navigate('/overview') }}
                                        >
                                            {billingContent?.billing_autopay_goto_dashboard_text}
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <>
                    <div className="row" id="wizardRow">
                        <div className="col-md-12 text-start paymentoptionsscreen">
                            <div className="wizard-form" tabIndex={0}>
                                <ul id="progressBar" className="progressbar">
                                    {autopayAccount?.count < 1 && (
                                        <li
                                        className={`d-inline-block fw-medium w-50 position-relative text-start float-start progressbar-list progressbar-list1 ${Payload?.owning_carrier === 'Q5' ? 'spantextcolor':''} ${activeStep === 1 ? 'active' : ''}`} 
                                        >
                                            {billingContent?.billing_autopay_select_payment_title}
                                        </li>
                                    )}
                                    <li
                                        className={`d-inline-block fw-medium list-blue w-50 position-relative text-start float-start ${autopayAccount?.count < 1 ? 'progressbar-list' : ''} ${Payload?.owning_carrier === 'Q5' ? 'spantextcolor':''} ${activeStep === 2 ? 'active' : ''}`}
                                    >
                                        {autopayAccount?.count < 1 ? billingContent?.billing_autopay_review_activate_title : billingContent?.billing_autopay_review_deactivate_title}

                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {activeStep === 1 && (
                        <div className="row justify-content-center" id="cardSection" role="region" aria-label="Select Payment Options" ref={step1Ref} tabIndex="-1" style={{ outline: 'none' }}>
                            <div className="col-12">
                                <div className="col-12 d-xl-flex d-md-flex d-sm-block d-block">
                                    <div className="col-xl-6" tabIndex={0}>
                                        <h5 className="small pt-4 pb-2">{billingContent?.billing_autopay_current_status_text} {billingContent?.billing_autopay_autopay_text} {autopayAccount?.count > 0 ? 'on' : 'off'}</h5>
                                    </div>
                                    <div className="col-xl-6 mt-4" tabIndex={0}>
                                        {billingInfoErrorFlag && (
                                            <div className="api-error-msg">
                                                {genericContent?.finance_service_error}
                                            </div>
                                        )}
                                        {isBillingInfoLoading &&
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit' }} aria-label="Loading billing information">
                                                <Spinner animation="border" role="status" aria-hidden="true"></Spinner>
                                                <div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
                                            </div>
                                        }
                                        {!isBillingInfoLoading && !billingInfoErrorFlag &&
                                            <div className="d-flex">
                                                <span className="wallet-cards lh-xl me-3">
                                                    <img src={Walletcard} width="30" height="30" alt="Wallet-Amount" />
                                                </span>
                                                <h5 className={Payload?.owning_carrier === 'Q5' ? "mt-1 fw-semibold autopay-due spantextcolor" : "mt-1 fw-semibold autopay-due"}>
                                                    {billingContent?.billing_autopay_debit_amount_text}
                                                    <label class="mt-2 d-block fw-normal text-start">
                                                        <span>{billingInfo?.CurrentDueAmount}</span>
                                                    </label>
                                                </h5>
                                            <h5 className={Payload?.owning_carrier === 'Q5' ? "mt-1 fw-semibold autopay-due ms-3 spantextcolor": "mt-1 fw-semibold autopay-due ms-3"}>
                                                    {billingContent?.billing_autopay_due_date_text}
                                                    <label class="mt-2 d-block fw-normal text-start">
                                                        <span><i class="fe fe-clock"></i> {billingInfo?.DueDate}</span>
                                                    </label>
                                                </h5>
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div className="col-12 mt-sm-2 mt-xl-0 mt-md-0 mt-2" tabIndex={0}>
                                    <p className="small">{billingContent?.billing_autopay_payment_methods_text}</p>
                                </div>

                                <div className="col-12 mt-2 error-message" tabIndex={0}>
                                    {!isLoading && !errorFlag && !selectedCard && (
                                        Payload?.owning_carrier === 'Q5' ? (
                                            <p className="" style={{ fontSize: '14px', fontWeight: 'normal' }}>
                                                {billingContent?.billing_autopay_account_selection_error_text}
                                            </p>
                                        ) : (
                                            <p className="text-danger">
                                                <i className="fe fe-alert-circle me-1"></i>
                                                {billingContent?.billing_autopay_account_selection_error_text}
                                            </p>
                                        )
                                    )}
                                </div>


                                <div className="row row-cols-1 row-cols-lg-1 g-3 pb-5 border-bottom bottom-padding">
                                    {errorFlag && (
                                        <div className="api-error-msg">
                                            {genericContent?.accounts_info_service_error}
                                        </div>
                                    )}
                                    {isLoading ? (
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit' }} aria-label="Loading payment accounts">
                                            <br/><br/><br/><Spinner animation="border" role="status" aria-hidden="true"></Spinner>
                                            <div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
                                        </div>
                                    ) : groupedAccounts.length > 0 && !errorFlag && activeAccounts ? (
                                        <Carousel
                                            id="carouselautopay"
                                            indicators={false}
                                            controls={true}
                                            interval={null}
                                            prevIcon={<img src={previousarrow} alt="previousarrow" onClick={gotoPrev} onKeyDown={onKeyDown} />}
                                            nextIcon={<img src={nextarrow} alt="nextarrow" onClick={gotoNext} onKeyDown={onKeyDown} />}
                                        >
                                            {groupedAccounts.map((method, index) => (
                                                <Carousel.Item key={index}>
                                                    <div className="col-autopay">
                                                        {method.map((card, key) => (
                                                            <div
                                                                id={index+'-'+key}
                                                                key={card.tokenId.trim()}
                                                                tabIndex={index === active ? 0 : -1}
                                                                role="option"
                                                                aria-live="polite"
                                                                aria-atomic="true"
                                                                aria-selected={index === active}
                                                                ref={(el) => (active === 0 ? (slideRefs.current[0] = el) : (action === 'prev') ? (slideRefs.current[index] = el) : (slideRefs.current[index+1] = el))}
                                                                className="text-start h-100 col-6 px-3 pb-1 d-inline-block "
                                                                onClick={() => handleCardSelect(card.tokenId.trim(), card.accountNumLastFour)}
                                                                onKeyDown={(e) => {
                                                                    if(e.key === 'Enter'){
                                                                        e.preventDefault();
                                                                        handleCardSelect(card.tokenId.trim(), card.accountNumLastFour)}
                                                                    }
                                                                }
                                                            >
                                                                <div id={card.tokenId.trim()} className={`px-2 pb-2 pt-2 cards-autopay ${card.tokenId.trim() === cardId ? 'selected-card' : ''}`}>
                                                                    <div className="d-xl-flex d-md-flex d-sm-block">
                                                                        <div className="col-xl-7">
                                                                            <img src={card.icon} alt={card.detailedAccountType} />
                                                                            <h5 className="card-title title-binding fw-normal cardsnumber">
                                                                                {billingContent?.billing_autopay_card_no_star} {card.accountNumLastFour}
                                                                            </h5>
                                                                        </div>
                                                                        <div className="col-xl-5 text-end">
                                                                            <label className="d-block">
                                                                                <span className="bg-light d-inline-block text-center rounded-3" style={{width: (card?.mainAccountType === 'EFT' && Cookies.get('owningCarrier') === 'Q5') ? '75px' : '40px'}} aria-label={card?.mainAccountType === 'EFT' ? billingContent?.billing_autopay_eft_txt : card?.mainAccountType.toUpperCase()}>
                                                                                    {card?.mainAccountType === 'EFT' ? billingContent?.billing_autopay_eft_txt : (Cookies.get('owningCarrier') === 'Q5' ? billingContent?.billing_debit_txt : card?.mainAccountType.toUpperCase())}
                                                                                </span>
                                                                            </label>
                                                                            {(primaryAccount?.MainAccountType === card?.mainAccountType && primaryAccount?.vault_id === card?.vaultId && primaryAccount?.primaryActive === 'Y') && (
                                                                                <button tabIndex={-1} aria-label="primary account" className={Payload?.owning_carrier === 'Q5' ? "btn btn-primary btn-sm rounded" : "btn btn-warning btn-sm rounded"}>{billingContent?.billing_autopay_primary_account}</button>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </Carousel.Item>
                                            ))}
                                        </Carousel>
                                    ) : (!errorFlag && !isLoading && (
                                        <div className='labels' tabIndex={0}><label className='label-heading'>{billingContent?.billing_autopay_no_accounts_found_text}</label></div>
                                    ))}

                                    <div className="col-12" tabIndex={0}>
                                        <div className="text-start h-100 col-6 px-3 pb-1">
                                            <div
                                                className="card-body px-3 pb-3 pt-3 cards-border"
                                                style={{ cursor: 'pointer' }} // Add pointer cursor to indicate it's clickable
                                                onClick={() => setShowModal(true)}
                                            >
                                                <img src={PlusIcon} className="align-top" alt="Add payment" />
                                                <h5 className="card-title title-binding fw-normal ms-2 d-inline-block">
                                                    {billingContent?.billing_autopay_add_payment_text}
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                    <Modal size='xl' show={showModal} onHide={() => setShowModal(false)}>
                                        <Forms handleCloseModal = {handleCloseModal} sendDataToParent={handleAddNewDataForm}/>
                                    </Modal>

                                    <div className="col-12 mt-2 ms-xl-3 ms-md-3" tabIndex={0}>
                                        <p>
                                            <img src={EncryptIcon} className="me-2" alt="Encryption" />
                                            {billingContent?.billing_autopay_secure_msg}
                                        </p>
                                    </div>

                                    <div className="grey-bg rounded px-4 py-4 mb-4 custom-rounded" tabIndex={0}>
                                        <p>
                                        <b>{billingContent?.billing_autopay_note}</b>
                                        {billingContent?.billing_autopay_note_content}
                                        </p>
                                    </div>
                                </div>

                                <div tabIndex={0}>
                                    <button
                                    type="button"
                                    className="btn btn-primary btn-lg float-end next mt-4 next-button"
                                    onClick={handleNext}
                                    disabled={!selectedCard}
                                    aria-label={!selectedCard ? "disabled until a payment method is selected" : "proceed to next step"}
                                    >
                                    {billingContent?.billing_autopay_next_btn_text}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {activeStep === 2 && (
                        <div className="row py-3 form-business" role="region" aria-label="Review and Activate" ref={step2Ref} tabIndex="-1" style={{ outline: 'none' }}>
                            <div className="col-12" id="successForm">
                                <p tabIndex={0} className="small pb-2">{autopayAccount?.count < 1 ? billingContent?.billing_autopay_review_card_text : billingContent?.billing_autopay_deactivate_confirm_text}</p>
                                <p tabIndex={0} className="small">{billingContent?.billing_autopay_selected_card_text}</p>

                                <div className="col-12">
                                    <div className="text-start h-100 mb-3">
                                        <div className="card-body px-3 pb-4 pt-4 cards-border">
                                            <div className="col-12 d-flex">
                                                <div className="col-4" tabIndex={0}>
                                                    <label className="d-block fw-semibold">
                                                        <img
                                                            src={getSelectedCardDetails()?.icon}
                                                            className="me-2"
                                                            alt={getSelectedCardDetails()?.mainAccountType === 'EFT' ? getSelectedCardDetails()?.detailedAccountType+' EFT account' : (getSelectedCardDetails()?.detailedAccountType === 'MC' ? 'MasterCard account' : getSelectedCardDetails()?.detailedAccountType+' account')}
                                                        />
                                                        {billingContent?.billing_autopay_card_no_star} {getSelectedCardDetails()?.accountNumLastFour}
                                                    </label>
                                                    <label className="d-block mt-2">
                                                        {billingContent?.billing_autopay_expires_on_text} {getSelectedCardDetails()?.ExpiryDate}
                                                    </label>
                                                </div>
                                                <div className="col-4" tabIndex={0}>
                                                    <label className="d-block fw-semibold">
                                                        {getSelectedCardDetails()?.accountName}
                                                    </label>
                                                    <label className="d-block mt-2">
                                                        {getSelectedCardDetails()?.mainAccountType === 'EFT' ? billingContent?.billing_autopay_account_name_text : billingContent?.billing_autopay_name_on_card_text}
                                                    </label>
                                                </div>
                                                <div className="col-4" tabIndex={0}>
                                                    <label className="d-block fw-semibold">
                                                        {getSelectedCardDetails()?.detailedAccountType === 'MC' || getSelectedCardDetails()?.detailedAccountType === 'VISA' ? billingContent?.billing_autopay_credit_card_text : billingContent?.billing_autopay_bank_account_text }
                                                    </label>
                                                    <label className="d-block mt-2">
                                                        {billingContent?.billing_autopay_type_text}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                {/* <div className="col-xl-12 text-start mt-3">
                                    <Form.Check
                                        type="switch"
                                        id="autopay-switch"
                                        label={billingContent?.billing_autopay_enable_text}
                                        checked={autopayEnabled}
                                        onChange={(e) => setAutopayEnabled(e.target.checked)}
                                    />
                                </div> */}

                                {autopayAccount?.count < 1 && (
                                    <div className="col-xl-12">
                                        <div className="mb-0 mt-4 enableautopay d-grid-tbl">

                                            {parse(modifiedNachaAuthContent)}

                                            {parse(nachaNoticeCancelContent)}

                                            {parse(nachaContentHolderContent)}
                                        </div>
                                    </div>
                                )}

                                {autopayAccount?.count < 1 && (
                                    <div className="col-xl-12 mt-4 form-checkbox">
                                        <form>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="flexCheckDefault3"
                                                aria-label="online-payment"
                                                name="flexCheckDefault3"
                                                checked={termsAccepted}
                                                onChange={(e) => setTermsAccepted(e.target.checked)}
                                            />
                                            <label tabIndex={0} className="form-label grey-heading d-inline-block mt-1 ms-2">
                                                {billingContent?.billing_autopay_cc_recurring_agreement_text}
                                            </label>
                                        </form>
                                    </div>
                                )}

                                {/* Q5 carrier: Responsive button order for Activate/Back in step 2 */}
                                {Payload?.owning_carrier === 'Q5' ? (
                                    <>
                                        {/* Mobile/Tablet: Active button first, Back button at bottom */}
                                        <div className="d-block d-lg-none w-100">
                                            {isAutopayLoading ? (
                                                <div tabindex={0} className='autopay-loading' aria-label="Activating autopay">
                                                    <Spinner animation="border" role="status" aria-hidden="true"></Spinner>
                                                    <div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
                                                </div>
                                            ) : (
                                                <div tabIndex={0}>
                                                    {autopayEnabled ? (
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-lg float-end next mt-4 btn-lg activate-button submit-button"
                                                            onClick={(e) => handleAutopay(getSelectedCardDetails()?.mainAccountType, getSelectedCardDetails()?.vaultId)}
                                                            disabled={!termsAccepted}
                                                            aria-label={!termsAccepted ? "activate button is disabled until payment terms checkbox is selected" : "activate autopay"}
                                                        >
                                                            {billingContent?.billing_autopay_activate_btn_text}
                                                        </button>
                                                    ) : (
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-lg float-end next mt-4 btn-lg activate-button submit-button"
                                                            onClick={(e) => handleAutopay(getSelectedCardDetails()?.mainAccountType, getSelectedCardDetails()?.vaultId)}
                                                            aria-label={"deactivate autopay"}
                                                        >
                                                            {billingContent?.billing_autopay_deactivate_btn_text}
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                            {autopayAccount?.count < 1 && (
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-secondary btn-lg float-start back mt-4 back-button"
                                                    onClick={handleBack}
                                                >
                                                    {billingContent?.billing_autopay_back_btn_text}
                                                </button>
                                            )}
                                        </div>
                                        {/* Large screens: Back button first, Active button second */}
                                        <div className="d-none d-lg-flex w-100 justify-content-between">
                                            {autopayAccount?.count < 1 && (
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-secondary btn-lg float-start back mt-4 back-button"
                                                    onClick={handleBack}
                                                >
                                                    {billingContent?.billing_autopay_back_btn_text}
                                                </button>
                                            )}
                                            {isAutopayLoading ? (
                                                <div tabindex={0} className='autopay-loading' aria-label="Activating autopay">
                                                    <Spinner animation="border" role="status" aria-hidden="true"></Spinner>
                                                    <div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
                                                </div>
                                            ) : (
                                                <div tabIndex={0}>
                                                    {autopayEnabled ? (
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-lg float-end next mt-4 btn-lg activate-button submit-button"
                                                            onClick={(e) => handleAutopay(getSelectedCardDetails()?.mainAccountType, getSelectedCardDetails()?.vaultId)}
                                                            disabled={!termsAccepted}
                                                            aria-label={!termsAccepted ? "activate button is disabled until payment terms checkbox is selected" : "activate autopay"}
                                                        >
                                                            {billingContent?.billing_autopay_activate_btn_text}
                                                        </button>
                                                    ) : (
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-lg float-end next mt-4 btn-lg activate-button submit-button"
                                                            onClick={(e) => handleAutopay(getSelectedCardDetails()?.mainAccountType, getSelectedCardDetails()?.vaultId)}
                                                            aria-label={"deactivate autopay"}
                                                        >
                                                            {billingContent?.billing_autopay_deactivate_btn_text}
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        {autopayAccount?.count < 1 && (
                                            <button
                                                type="button"
                                                className="btn btn-outline-secondary btn-lg float-start back mt-4 back-button"
                                                onClick={handleBack}
                                            >
                                                {billingContent?.billing_autopay_back_btn_text}
                                            </button>
                                        )}
                                        {isAutopayLoading ? (
                                            <div tabindex={0} className='autopay-loading' aria-label="Activating autopay">
                                                <Spinner animation="border" role="status" aria-hidden="true"></Spinner>
                                                <div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
                                            </div>
                                        ) : (
                                            <div tabIndex={0}>
                                                {autopayEnabled ? (
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary btn-lg float-end next mt-4 btn-lg activate-button submit-button"
                                                        onClick={(e) => handleAutopay(getSelectedCardDetails()?.mainAccountType, getSelectedCardDetails()?.vaultId)}
                                                        disabled={!termsAccepted}
                                                        aria-label={!termsAccepted ? "activate button is disabled until payment terms checkbox is selected" : "activate autopay"}
                                                    >
                                                        {billingContent?.billing_autopay_activate_btn_text}
                                                    </button>
                                                ) : (
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary btn-lg float-end next mt-4 btn-lg activate-button submit-button"
                                                        onClick={(e) => handleAutopay(getSelectedCardDetails()?.mainAccountType, getSelectedCardDetails()?.vaultId)}
                                                        aria-label={"deactivate autopay"}
                                                    >
                                                        {billingContent?.billing_autopay_deactivate_btn_text}
                                                    </button>
                                                )}
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    )}
                </>
            )}  
        </Modal.Body>
    );
};

export default AutoPayModal;